module.exports = __webpack_public_path__ + "static/Europos-egzaminas-logo-d5a568134d8a5297cb2b0c1781e6b47c.svg";